/**
 * Simple utility to enqueue tasks (promises) to run sequentially. Resolved values and thrown errors are
 * just ignored. Do not use this if you require obtaining results from the queued tasks.
 */
export default class QueuedExecutorService {
    private tasks: Function[] = [];
    private status: number = ExecutorStatus.IDLE;

    get size(): number {
        return this.tasks.length;
    }

    get hasPendingTasks(): boolean {
        return this.size > 0;
    }

    public add(task: Function | Array<Function>): void {
        if (Array.isArray(task)) {
            task.map(task => this.add(task));
            return;
        }

        if (typeof task !== 'function') {
            throw new Error('You can only enqueue functions');
        }
        this.tasks.push(task);
        this.start();
    }


    private start(): void {
        if (this.status !== ExecutorStatus.RUNNING && this.hasPendingTasks) {
            this.status = ExecutorStatus.RUNNING;

            (async () => {
                while (this.hasPendingTasks) {
                    // The key to force sequential execution is just to await for promises to resolve between tasks.
                    await this.runNextTask();
                }
                this.status = ExecutorStatus.IDLE;
            })();
        }
    }

    private async runNextTask(): Promise<void> {
        const nextTask = this.tasks.shift();
        if (nextTask) {
            await nextTask();
        }
    }

}

const ExecutorStatus = {
    IDLE   : 0,
    RUNNING: 1
}